export default {
  ActivityLogImportJob: 'Importação de log de atividades',
  AllSurveysDataMigrationJob: 'Migração de dados de todos os inventários',
  ArenaMobileDataImportJob: 'Importação de dados do Arena',
  ArenaMobileDataImportSummaryJob: 'Resumo da importação de dados do Arena',
  CategoriesImportJob: 'Importação de categorias',
  CategoriesValidationJob: 'Validação de categorias',
  CategoriesBatchImportJob: 'Importação de categorias',
  CategoryImportJob: 'Importação de categoria',
  CategoryImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryValidationJob: 'Validação de categoria',
  ChainsSamplingNodeDefsCheckJob: 'Criação de definições de nós amostrais das cadeias de processamento',
  ChainsValidationJob: 'Validação de cadeias de processamento',
  ChainsImportJob: 'Importação de cadeias',
  CollectDataImportJob: 'Importação de dados do Collect',
  CollectImportJob: 'Importação do Collect',
  CollectSurveyReaderJob: 'Leitor de inventário do Collect',
  CyclesDeletedCheckJob: 'Verificação de ciclos excluídos',
  DataDeleteJob: 'Exclusão de dados',
  DataImportJob: 'Importação de dados',
  DataImportValidationJob: 'Validação de arquivo de importação de dados',
  EntitiesDeleteJob: 'Exclusão de entidades existentes',
  FilesImportJob: 'Importação de arquivos',
  MessageSendJob: 'Envio de mensagem',
  NodeDefsTranslationJob: 'Tradução de rótulos de definições de nós',
  NodeDefsImportJob: 'Importação de definições de nós',
  NodeDefsValidationJob: 'Validação de definições de nós',
  OdkImportJob: 'Importação do ODK',
  OdkDataImportJob: 'Importação de dados do ODK',
  OdkFormReaderJob: 'Leitor de formulário do ODK',
  OdkSubmissionReaderJob: 'Leitor de submissões do ODK',
  ChainsCyclesCheckJob: `Verificação de ciclos das cadeias`,
  RecordCheckJob: 'Verificação de registro',
  RecordsCloneJob: 'Clonagem de registros',
  RecordsImportJob: 'Importação de registros',
  RecordsImportSummaryJob: 'Resumo da importação de registros',
  RecordsUniquenessValidationJob: 'Validação de unicidade de registros',
  SamplingPointDataImportJob: 'Importação de dados de pontos amostrais',
  SamplingPointDataImportInternalJob: 'Importação de dados de pontos amostrais',
  SchemaSummaryExportJob: 'Exportação do resumo do esquema',
  SelectedRecordsExportJob: 'Exportação de registros selecionados',
  SurveyActivityLogClearJob: 'Limpeza do log de atividades do inventário',
  SurveyCreatorJob: 'Criação de inventário',
  SurveyDataMigrationJob: 'Migração de dados do inventário',
  SurveyDependencyGraphsGenerationJob: 'Geração de grafos de dependência do inventário',
  SurveyExportJob: 'Exportação de inventário',
  SurveyCompareJob: 'Comparação de inventários',
  SurveyCompareDiffJob: 'Cálculo das diferenças',
  SurveyCompareApplyJob: 'Aplicação das alterações do inventário',
  SurveyFilesImportJob: 'Importação de arquivos do inventário',
  SurveyIndexGeneratorJob: 'Gerador de índice do inventário',
  SurveyInfoValidationJob: 'Validação de informações do inventário',
  SurveyLabelsImportJob: 'Importação de rótulos do inventário',
  SurveyPropsPublishJob: 'Publicação de propriedades do inventário',
  SurveyPublishJob: 'Publicação de inventário',
  SurveyPublishPerformJob: 'Execução da publicação de inventário',
  SurveyRdbCreationJob: 'Criação de RDB do inventário',
  SurveyRdbSchemaCreationJob: 'Criação do esquema de RDB do inventário',
  SurveyRdbDataTablesAndViewsCreationJob: 'Criação de tabelas e visões de dados de RDB do inventário',
  SurveyRdbOlapDataTablesCreationJob: 'Criação de tabelas de dados OLAP de RDB do inventário',
  SurveyUnpublishJob: 'Despublicação de inventário',
  SurveyPropsUnpublishJob: 'Despublicação de propriedades do inventário',
  SurveysListExportJob: 'Exportação de lista de inventários',
  SurveysRdbRefreshJob: 'Atualização de RDB dos inventários',
  TaxonomiesImportJob: 'Importação de taxonomias',
  TaxonomiesValidationJob: 'Validação de taxonomias',
  TaxonomyImportJob: 'Importação de taxonomia',
  UsersBackupExportJob: 'Backup de usuários',
  UsersBackupImportJob: 'Restauração de usuários',
  // data export
  ArenaFileReadJob: 'Leitura de arquivo do Arena',
  DataExportJob: 'Exportação de dados',
  DataMatrixExportJob: 'Exportação de matriz de dados',
  DataSummaryExportJob: 'Exportação de resumo de dados',
  ZipCreationJob: 'Criação de arquivo ZIP',
  CSVDataExtraction: 'Extração de dados',
  FilesExportJob: 'Exportação de arquivos',
  PrepareImportFileJob: 'Preparar arquivo de importação',
  // geo
  GeoJsonDataExportJob: 'Exportação de dados GeoJSON',
  // import arena survey
  ArenaImportJob: 'Importação do Arena',
  ArenaSurveyReaderJob: 'Leitor de inventário do Arena',
  CreateRdbJob: 'Criação de RDB do inventário',
  UsersImportJob: 'Importação de usuários',
  // clone survey
  SurveyCloneJob: 'Clonar inventário',
  CloneSurveyJob: 'Clonar inventário',
  // survey backup
  SurveyInfoExportJob: 'Exportação de informações do inventário',
  CategoriesExportJob: 'Exportação de categorias',
  CategoryGeoPackageExportJob: 'Exportação de categoria para GeoPackage',
  SamplingPointDataWhispJob: 'Análise Whisp dos dados de pontos de amostragem',
  SamplingPointDataWhispAnalysisJob: 'Análise Whisp',
  SamplingPointDataWhispCategoryImportJob: 'Importação da categoria Whisp',
  TaxonomiesExportJob: 'Exportação de taxonomias',
  RecordsExportJob: 'Exportação de registros',
  RecordFilesExportJob: 'Exportação de arquivos de registros',
  SurveyFilesExportJob: 'Exportação de arquivos da pesquisa',
  ChainExportJob: 'Exportação de cadeia',
  UsersExportJob: 'Exportação de usuários',
  ActivityLogExportJob: 'Exportação de log de atividades',
  InfoExportJob: 'Geração de informações do arquivo de saída',
  // validation Report
  VaidationReportGenerationJob: 'Gerar relatório de validação',
  // record Validation
  RecordsValidationJob: `Validação de registros`,
  // analysis
  PersistResultsJob: 'Persistência dos resultados da análise',
  PersistOlapDataJob: 'Persistência de dados OLAP',
}
